export enum ApproveRequiredTypesEnum {
  REQUIRED = 'REQUIRED',
  NON_REQUIRED = 'NON_REQUIRED',
  PROMPTLY = 'PROMPTLY',
}
